var _style, _g, _path, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    viewBox: "105.3 130 342.2 342.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0a{fill:#FCC010;}\n\t.st1a{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0a",
    cx: 276.4,
    cy: 301.1,
    r: 170.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0a",
    d: "M276.4,131c94,0,170.1,76.2,170.1,170.1s-76.2,170.1-170.1,170.1s-170.1-76.2-170.1-170.1S182.4,131,276.4,131    M276.4,130c-45.7,0-88.7,17.8-121,50.1s-50.1,75.3-50.1,121s17.8,88.7,50.1,121s75.3,50.1,121,50.1s88.7-17.8,121-50.1   s50.1-75.3,50.1-121s-17.8-88.7-50.1-121S322.1,130,276.4,130L276.4,130z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1a",
    d: "M391.2,406.8c-5.9-17.1-19.7-32.3-39.2-43.2c-7.1-4-14.9-7.3-23.1-10c-2.3-0.8-4.9-0.3-6.8,1.1  c-12.9,9.9-28.6,15.7-45.6,15.7c-16.5,0-31.9-5.5-44.6-15c-2-1.5-4.6-1.8-6.9-1c-30.4,10.6-53.4,30.2-61.3,54.3  c-0.4,1.2,26.7,23.6,26.7,23.6l26.8,13l27.6,8.5l25.1,3.1l28.2-2.2l32.1-7.1l34.3-17.6C364.3,430,391.7,408.3,391.2,406.8z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1a",
    cx: 276.4,
    cy: 283.7,
    rx: 59.4,
    ry: 67.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.866a6caabee3f67119a0dc77fad9d861.svg";
export { ForwardRef as ReactComponent };